import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";

interface ChartInDialogButtonProps {
  identifier: string;
  identifiers?: string[];
  dateFrom?: Date;
  dateTo?: Date;
  header?: string;
  setIsDialogOpen?: (value: boolean) => void;
}

const ChartInDialogButton = ({
  dateFrom,
  dateTo,
  identifier,
  identifiers,
  header,
  setIsDialogOpen,
}: ChartInDialogButtonProps) => {
  const [isDialogVisible, setDialogVisibility] = useState(false);
  useEffect(() => {
    if (isDialogVisible && setIsDialogOpen) {
      setIsDialogOpen(true);
    }
  }, [isDialogVisible]);

  return (
    <>
      <i
        className="pi pi-chart-line"
        onClick={(e) => {
          if (e.ctrlKey) {
            return;
          }
          setDialogVisibility(true);
        }}
        style={{ cursor: "pointer" }}
      />
      <Dialog
        header={header || "Chart"}
        onHide={() => {
          setDialogVisibility(false);
        }}
        visible={isDialogVisible}
        style={{ width: "min(100vw, 1000px)", height: "500px" }}
        modal={false}
        resizable
        draggable
        maximizable
      >
        <DatasetLineChart
          dateFrom={dateFrom}
          dateTo={dateTo}
          identifiers={identifiers && identifiers?.length > 0 ? identifiers : [identifier]}
          dynamicHeight
          showDateSelection
          chartDialogOpen={isDialogVisible}
          title=""
        />
      </Dialog>
    </>
  );
};

export default ChartInDialogButton;
